export const siteConstants = {
  DEFAULT_TITLE: "Hong Bao Media: Media Training & Executive Coaching",
  TITLE_TEMPLATE: "%s | Hong Bao Media",
  ERROR_MSG_SERVER_COMMUNICATION: "There's a problem communicating to server",
  ERROR_MSG_FAILED_TO_RETRIEVE_USER: "Failed to retrieve user",
  ERROR_MSG_INVALID_GUIDANCE_DATABASE_FILE: "Invalid guidance database file",
  ERROR_MSG_INVALID_CS_REPORT_FILE: "Invalid CS report file",
  ERROR_MSG_INVALID_THINKIFIC_DISCOUNT_CODES_FILE: "Invalid Thinkific discount codes file",
  SOURCE_COMMSCOACHING: "commscoaching",
  SOURCE_COUPLECOACHING: "couplecoaching",
  SOURCE_SUCCESSIONPLANNING: "successionplanning",
  ORDER_LIST_DAYS: 90,
  CS_REPORT_LIST_DAYS: 90,
}